import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-app-section',
  templateUrl: './download-app-section.component.html',
  styleUrls: ['./download-app-section.component.scss'],
})
export class DownloadAppSectionComponent implements OnInit {
  constructor() {}
  socialPages = [
    {img:'https://media.umangapp.in/cdn/landing/theme/icons/facebook.svg', url:'https://www.facebook.com/OfficialUmangApp', title:'facebook', alt:'facebook'},
    {img:'https://media.umangapp.in/cdn/landing/theme/icons/linkedin.svg', url:'https://www.linkedin.com/company/umangapp/', title:'Linkedin', alt:'Linkedin'},
    {img:'https://media.umangapp.in/cdn/landing/theme/icons/youtube.svg', url:'https://www.youtube.com/channel/UCejhcTgTo0PHDp3rrrM7jKg', title:'youTube', alt:'youTube'},
    {img:'https://media.umangapp.in/cdn/landing/theme/icons/instagram.svg', url:'https://www.instagram.com/official.umang/', title:'Instagram', alt:'Instagram'},
    {img:'https://media.umangapp.in/cdn/landing/theme/icons/x.svg', url:'https://twitter.com/UmangOfficial_', title:'X', alt:'X'}
  ]
  ngOnInit() {}

  socialLinkRedirect(link:any){
    window.open(link, '_blank');
  }
}
